module.exports = __webpack_public_path__ + "static/img/slide_small2.61bcdf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide_small2.png
// module id = ojg0
// module chunks = 4